import Card from "@components/global/new/Card/Card";
import { Button } from "antd";
import minerIcon from "../../assets/miner-homepage.svg";
import styles from "./RecentHashrateCard.module.scss";
import { useIntl } from "react-intl";
import { useState } from "react";
import { RecentHashrateChart } from "../RecentHashrateChart/RecentHashrateChart";

function RecentHashrateCard() {
  const { formatMessage } = useIntl();
  const [activeMiners, setActiveMiners] = useState<number | null>(null);

  return (
    <Card className={styles.card}>
      <div className={styles.head}>
        <div>
          <h2>{formatMessage({ id: "wlp.hashrate.title" })}</h2>
        </div>
      </div>
      <div className={styles.chartWrap}>
        <div className={styles.toolbar}>
          <Button type="primary" className={styles.placeholderChip}>
            <img src={minerIcon} alt="" />
            {activeMiners !== null
              ? `${activeMiners} ${formatMessage({ id: "wlp.hashrate.activeMinersSuffix" })}`
              : formatMessage({ id: "wlp.hashrate.activeMiners" })}
          </Button>
        </div>
        <RecentHashrateChart onActiveMinersChanged={setActiveMiners} />
      </div>
    </Card>
  );
}

export { RecentHashrateCard };
